import React, { Component } from 'react';
import TabComponent from '../TabComponent';
import MultiDropDown from '../MultiDropDown/MultiDropDown';
import CloseUpSVG from '../../svg/CloseUpSVG';
import ArrowUpSVG from '../../svg/ArrowUpSVG';
import EditUpSVG from '../../svg/EditUpSVG';
import { withStore } from '../store';
import EditContact from '../EditContact';
import CheckBoxSVG from '../../svg/CheckBoxSVG';
import { Service } from '../ApiService';
import InputWithClearButton from '../InputWithClearButton'
import { createValidators } from '../storeValidatorsRules'
import { alertNotValid } from '../alerts'
import CheckBox from '../CheckBox';
import DeleteUpSVG from '../../svg/DeleteUpSVG';
import SaveUpSVG from '../../svg/SaveUpSVG'
import ReturnUpSVG from '../../svg/ReturnUpSVG'
import Alert from '../Alert'
import Loader from '../Loader';
import { CirclePicker } from 'react-color'
import ToggleButton from 'react-toggle-button'
import './Event.css'

class EventType extends Component {

    constructor(props) {
        super(props);
        props.store.refreshUserInfo();
        let id = 0;
        if (props.match.params.id) {
            id = props.match.params.id
        }
        this.state = {
            eventType: {
                id: id,
                title: '',
                color: '',
                order: 0,
                deleted: false
            },
            loading: false,
            showError: false,
            error: '',
            showDeleteDialog: false,
            showSuccessfullySavedDialog: false,
        };
    }

    componentWillMount() {
        let eventTypeValidators = [
            { 'name': 'title', 'typeFunction': 'notEmptyString', 'text': 'Event type name' },
        ];
        this.validators = createValidators(eventTypeValidators);
        this.alertNotValid = alertNotValid(() => this.setState({ showError: false }));
    }

    componentDidMount = () => {
        if (this.state.eventType.id && this.state.eventType.id > 0) {
            this.setState({ loading: true }, () => {
                Service.getEventTypeById(this.state.eventType.id, (err) => console.log(err))
                    .then(data => {
                        this.setState({ eventType: data, loading: false })
                    });
            });
        }
    }

    setValue(key, value) {
        const state = this.state;
        state[key] = value;
        this.setState(state);
    }

    updateEventTypeProperty(property, value) {
        let temp = this.state.eventType;
        temp[property] = value;
        this.setState({ eventType: temp });
    }

    renderHeader() {
        if (this.props.match.path == '/new-event-type') {
            return (<h1 className='uppercase-text mb-2'>New<strong> Event type</strong></h1>)
        } else {
            return (<h1 className='uppercase-text mb-2'>Edit<strong> Event type</strong></h1>)
        }
    }

    performIfValid(callback) {
        //this.props.store.isFormValid(this.validators, this.state.service)
        if (
            this.props.store.isFormValid(this.validators, this.state.eventType)
        ) { callback() }
        else { this.setState({ showError: true }) };
    }

    saveEventType() {
        Service.saveEventType(this.state.eventType).then(data => {
            this.setState({ showSuccessfullySavedDialog: true });
        }).catch(data => alert(data));
    }

    close = () => { this.props.history.push('/event-types'); }

    render = () => {
        return (
            <div className='pages-wsm-wrapper ipw-600'>
                <div className='second-nav-wrapper'>
                    <div className='ipw-600'>
                        <div></div>
                        <div className='flex-nowrap'>
                            <button
                                className='round-button medium-round-button outline-on-hover'
                                onClick={() => this.performIfValid(() => this.saveEventType())}
                            >
                                <SaveUpSVG />
                                <span>Save</span>
                            </button>
                            <button
                                className='round-button medium-round-button outline-on-hover'
                                onClick={this.close}
                            >
                                <ReturnUpSVG />
                                <span>Exit</span>
                            </button>

                        </div>
                    </div>
                </div>

                {this.state.loading && <Loader />}

                {this.renderHeader()}

                <div style={{ "width": "100%", "maxWidth": "600px" }}>
                    <ul className='input-fields first-child-text-165 mt-1 pl-1 pr-1'>
                        <li>
                            <p>Event Type:</p>
                            <div className={this.props.store.checkIfShowError('title', this.validators) ? 'error-input-wrapper' : ''}>
                                <InputWithClearButton
                                    type='text'
                                    placeholder='Event Type Name'
                                    value={this.state.eventType.title}
                                    onChange={e => {
                                        this.updateEventTypeProperty("title", e.target.value)
                                        this.props.store.updateValidators("title", e.target.value, this.validators);
                                    }}
                                    onClearValue={() => {
                                        this.updateEventTypeProperty("title", "");
                                        this.props.store.updateValidators("title", "", this.validators);
                                    }}
                                />
                                {this.props.store.displayValidationErrors('title', this.validators)}
                            </div>
                        </li>
                        <li>
                            <p>Color:</p>
                            <CirclePicker className='fullWidth'
                                color={this.state.eventType.color}
                                onChange={(color) => {
                                    this.updateEventTypeProperty("color", color.hex);
                                }
                                }
                            />
                        </li>
                        <li className='marginContent'>
                            <p>Active:</p>
                            <ToggleButton style={{ 'margin-top': '10px', 'marginTop': '10px', 'padding-top': '10px', 'paddingTop': '10px'}}
                                value={!this.state.eventType.deleted}
                                thumbStyle={{ borderRadius: 2 }}
                                trackStyle={{ borderRadius: 2 }}
                                onToggle={(value) => {
                                    this.updateEventTypeProperty("deleted", value);
                                }} />
                        </li>


                    </ul>
                </div>

                {this.state.showError && this.alertNotValid}

                {this.state.showSuccessfullySavedDialog &&
                    <Alert
                        headerText='Success'
                        onClose={() => this.setState({ showSuccessfullySavedDialog: false })}
                        showOkButton={true}
                        onOkButtonClick={() => this.setState({ showSuccessfullySavedDialog: false }, () => this.props.history.push('/event-types'))}
                        okButtonText="Ok"
                        mode='success'
                    >
                        <h4 className='mb-05'>{this.state.eventType.title}</h4>
                        <p style={{ "textAlign": "center" }}> Was successfully saved </p>
                    </Alert>
                }
                {this.state.showError &&
                    <Alert
                        headerText='Error'
                        onClose={() => this.setState({ showError: false })}
                        showOkButton={true}
                        onOkButtonClick={() => this.setState({ showError: false })}
                        okButtonText="Ok"
                        mode='error'
                    >
                        <h4 className='mb-05'>Error while processing event type {this.state.eventType.title}</h4>
                        <p style={{ "textAlign": "center" }}> {this.state.error} </p>
                    </Alert>
                }
            </div>
        );
    }
}

export default withStore(EventType);


// WEBPACK FOOTER //
// ./src/components/event/EventType.jsx